import {Injectable, TemplateRef} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ContentHeaderService {
  content$ = new BehaviorSubject<TemplateRef<string> | null>(null);

  setContentHeader(templateRef: TemplateRef<string> | undefined) {
    if (templateRef) {
      this.content$.next(templateRef);
    }
  }
}
